module.exports = __webpack_public_path__ + "img/payamak-land.1347703e.png";